import script from "./ModalJustificativa.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalJustificativa.vue?vue&type=script&setup=true&lang=js"

import "./ModalJustificativa.vue?vue&type=style&index=0&id=4406d9a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4406d9a3"]])

export default __exports__